// NPM
/* Load npm scripts here */

// VENDOR
/* Load vendor modules here */

// BUNDLES
/* Load bundles here */
import defaultBundle from "bundles/default.bundle";

// COMPONENTS
/* Load components here */

// PAGE
/* load page specific scripts */
import flowboxGtm from "./partials/flowboxGtm";

// WRITE YOUR CODE HERE
defaultBundle();
flowboxGtm();
